import styled from "styled-components";

import awardBg from '@/images/everyday-award-bg.png'
import awardBgHover from '@/images/everyday-award-bg-hover.png'

import tip from '@/images/everyday-tip.png'

const View = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 440px;
  height: 470px;
  text-align: center;

  span.changeGame {
    display: inline-block;
    position: absolute;
    right: 80px;
    top: 25px;
    font-size: 16px;
    text-decoration: underline;
    color: #ffffff;
    cursor: pointer;
  }

  p.taskName {
    position: absolute;
    left: 50%;
    top: 98px;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: bold;
    color: #23419b;
  }

  p.tipTxt {
    position: absolute;
    left: 50%;
    top: 132px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #ffffff;

    span {
      display: inline-block;
      vertical-align: middle;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-left: 6px;
      cursor: pointer;
    }
  }

  ul {
    margin-top: 168px;
    width: 100%;
    height: 197px;
    text-align: center;

    li {
      display: inline-block;
      width: 134px;
      height: 197px;
      position: relative;
      background-image: url("${awardBg}");
      cursor: pointer;
      transition: all 0.15s;

      &:hover,
      &.active {
        background-image: url("${awardBgHover}");
      }

      img {
        width: 108px;
        height: 108px;
        position: absolute;
        left: 50%;
        top: 8px;
        transform: translateX(-50%);
      }

      p {
        font-size: 16px;
        color: #1a53b5;
        font-weight: bold;
        position: absolute;
        bottom: 30px;
        width: 100%;
      }
    }
  }

  .button {
    margin-top: 6px;
  }
`;
const ToolRule = styled.div`
  width: 289px;
  height: 210px;
  background-image: url(${tip});
  position: absolute;
  left: -60px;
  top: -50px;
`

export {
  View,
  ToolRule
}
